<style lang="less" scoped>
  .keypad {
    width: 100%;
  }
  .tabs-header {
    width: 100%;
    display: flex;
  }
  .tab {
    width: 44px;
    height: 36px;
    border-radius: 12px 12px 0 0;
    background: rgba(255, 255, 255, .4);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 1px;
    &.active {
      background-color: #ffffff;
    }
    img {
      width: 16px;
      height: 16px;
    }
  }
  .tab-content {
    width: 100%;
  }
  .tab-keypad {
    width: 100%;
    border-radius: 0 12px 12px;
    display: flex;
    flex-wrap: wrap;
    overflow: hidden;
    background: white;
  }
  .key {
    width: 14.28%;
    text-align: center;
    padding-top: 4px;
  }
  .used {
    opacity: .4;
  }
</style>

<template lang="pug">
  .keypad
    .tabs-header
      .tab(
        :class='{ active: tab === "heart" }'
        @click='tab = "heart"')
        img(
          v-if='tab !== "heart"'
          src='/static/tabs/default/heart.png')
        img(
          v-else
          src='/static/tabs/active/heart.png')
      .tab(
        :class='{ active: tab === "clover" }'
        @click='tab = "clover"')
        img(
          v-if='tab !== "clover"'
          src='/static/tabs/default/clover.png')
        img(
          v-else
          src='/static/tabs/active/clover.png')
      .tab(
        :class='{ active: tab === "spade" }'
        @click='tab = "spade"')
        img(
          v-if='tab !== "spade"'
          src='/static/tabs/default/spade.png')
        img(
          v-else
          src='/static/tabs/active/spade.png')
      .tab(
        :class='{ active: tab === "diamond" }'
        @click='tab = "diamond"')
        img(
          v-if='tab !== "diamond"'
          src='/static/tabs/default/diamond.png')
        img(
          v-else
          src='/static/tabs/active/diamond.png')
    .tab-content
      .tab-keypad
        .key(
          v-for='letter in letters')
          letter-component(
            v-if='cards.indexOf(tab + letter) === -1'
            @click.native='press(letter)'
            :type='color'
            :text='letter')
          letter-component.used(
            v-else
            :type='color'
            :text='letter')
</template>

<script>
import LetterComponent from '@/components/letter_panel';

export default {
  props: {
    used: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      tab: 'heart',
      letters: ['A', '2', '3', '4', '5', '6', '7', '8', '9', '10', 'J', 'Q', 'K'],
      cards: [],
    };
  },
  watch: {
    used() {
      this.cards = this.getCards();
    },
  },
  computed: {
    color() {
      let color = 'red';
      if (this.tab === 'clover' || this.tab === 'spade') {
        color = 'black';
      }
      return color;
    },
  },
  methods: {
    getCards() {
      const arr = [];
      for (let i = 0; i < this.used.length; i += 1) {
        const used = this.used[i];
        const shape = used.shape;
        const letter = used.card;
        console.log(shape, letter);
        arr.push(shape + letter);
      }
      return arr;
    },
    isUsed(letter, shape) {
      const obj = {
        card: letter,
        shape,
      };
      console.log(this.used, this.used.indexOf(obj));
      return this.used.indexOf(obj) !== -1;
    },
    press(letter) {
      const data = { shape: this.tab, card: letter };
      this.$emit('pressed', data);
    },
  },
  components: {
    LetterComponent,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/card_keypad.vue